import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/icons/icon-line-under-title.png'


const _hoisted_1 = { class: "memorial-audio" }
const _hoisted_2 = { class: "modal-intro group-fade" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line__wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_5 = { class: "role" }
const _hoisted_6 = { class: "modal-content group-fade" }
const _hoisted_7 = { class: "modal-split" }
const _hoisted_8 = { class: "main-titles" }
const _hoisted_9 = { class: "role" }
const _hoisted_10 = { class: "theme-info" }
const _hoisted_11 = {
  ref: "audio",
  crossorigin: "anonymous",
  controls: ""
}
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("code", null, "audio", -1)
const _hoisted_14 = ["src", "label", "srclang"]
const _hoisted_15 = { class: "modal-outro group-fade" }
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SoundWave = _resolveComponent("SoundWave")!
  const _component_SoundSubTitles = _resolveComponent("SoundSubTitles")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", {
              class: "name",
              ref: "spanTitle"
            }, _toDisplayString(_ctx.title), 513),
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.role), 1)
          ])
        ], 512), [
          [_vShow, _ctx.stepsModal == 1]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", {
                class: "name",
                ref: "spanTitle"
              }, _toDisplayString(_ctx.title), 513),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.role), 1)
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.visitorThemeInfo), 1)
          ]),
          (_ctx.isIOS && !_ctx.isPlaying)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-round-arrow next square-button display-audio",
                style: {"border-radius":"0 0 0 0"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playAudioFromButton && _ctx.playAudioFromButton(...args)))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("audio", _hoisted_11, [
            _createElementVNode("source", {
              src: _ctx.audio,
              type: "audio/mp3"
            }, null, 8, _hoisted_12),
            _hoisted_13,
            (_ctx.subtitle)
              ? (_openBlock(), _createElementBlock("track", {
                  key: 0,
                  src: _ctx.subtitle,
                  label: _ctx.languageLabel,
                  kind: "captions",
                  srclang: _ctx.$i18n.locale,
                  default: ""
                }, null, 8, _hoisted_14))
              : _createCommentVNode("", true)
          ], 512),
          _createVNode(_component_SoundWave, { ref: "soundwave" }, null, 512),
          _createVNode(_component_SoundSubTitles, { text: _ctx.captionText }, null, 8, ["text"])
        ], 512), [
          [_vShow, _ctx.stepsModal == 2]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", { innerHTML: _ctx.source }, null, 8, _hoisted_16)
        ], 512), [
          [_vShow, _ctx.stepsModal == 3]
        ])
      ]),
      _: 1
    })
  ]))
}